import { createIcon } from '@chakra-ui/react'

// export const FoxIcon = createIcon({
//   displayName: "FoxIcon",
//   viewBox: "0 0 2000 2000",

//   path: (
//     <path
//       fill='currentColor'
//       d='M10080 15633c-109-19-217-80-281-158-24-31-139-253-139-270 0-2-18-43-41-92-22-48-105-230-184-403s-157-344-173-380c-80-173-102-222-102-225 0-1-20-45-44-96-24-52-54-116-66-144-13-27-36-79-52-115-30-64-42-91-113-245-21-44-77-168-125-275s-104-229-123-270c-76-164-104-224-202-440-56-124-116-254-132-290-17-36-41-87-53-115-12-27-41-88-63-135-21-47-56-123-77-170s-59-130-85-185-66-143-90-195-59-129-78-170-45-97-57-125c-12-27-37-81-55-120-69-148-105-227-105-230 0-2-31-70-70-151-38-80-70-147-70-149 0-3-44-99-121-263-21-46-39-85-39-87s-23-52-51-112c-114-241-129-274-129-278 0-2-29-65-65-140s-65-138-65-140-27-60-60-130-60-128-60-130-41-91-125-270c-13-27-40-86-61-130-70-152-106-230-141-305-20-41-48-102-63-135s-49-105-75-160-76-163-112-240c-108-232-102-220-366-780-622-1324-943-1976-1029-2092-63-85-90-159-96-259-12-204 104-380 295-446l68-23h4540l67 23c124 43 222 135 272 255l21 52 5 1660 5 1660 88 3c48 1 87-1 87-5s5-84 10-178c5-93 14-260 20-370 5-110 17-328 25-485s19-373 25-480 17-321 25-475 19-368 25-475c45-889 43-862 98-963 59-110 181-194 314-217 44-7 649-10 2018-8l1955 3 60 22c134 51 225 142 271 270 28 82 32 193 8 273-13 42-136 334-219 515-7 17-41 93-75 170s-71 160-82 185-43 97-70 160c-28 63-58 133-68 155s-46 103-80 180c-33 77-67 154-75 170-15 33-158 359-292 665-47 107-96 218-108 245-12 28-46 104-75 170s-68 153-86 193c-19 41-34 76-34 79s-16 39-35 80-35 76-35 79c0 2-11 27-24 56s-50 112-81 183c-32 72-68 154-81 183s-36 80-50 115c-14 34-36 85-49 112-12 28-48 109-79 180-32 72-63 144-71 160-7 17-41 93-75 170s-72 164-86 193c-13 29-24 55-24 57 0 3-18 44-40 91s-40 88-40 90-11 27-24 56-68 152-121 273-112 254-130 295-59 134-90 205c-31 72-62 144-70 160-7 17-41 93-75 170s-72 163-84 190c-13 28-45 100-71 160-26 61-60 138-76 173s-29 65-29 68c0 2-18 43-40 90s-40 88-40 90-13 32-29 66c-15 35-76 173-135 308s-116 263-125 285c-10 22-44 99-76 170-31 72-63 144-70 160-7 17-41 93-75 170s-71 160-82 185-43 97-70 160c-28 63-63 143-79 178s-29 65-29 68c0 2-18 43-40 90s-40 88-40 90-16 38-35 80c-19 41-35 77-35 79 0 4-29 71-70 160-10 22-52 117-93 210-41 94-110 249-152 345s-81 185-86 197c-4 12-24 56-44 98-19 41-35 78-35 80 0 3-16 39-35 81-19 41-35 77-35 80 0 2-18 43-40 90s-40 88-40 90-9 23-20 47c-10 23-53 117-93 208-81 182-114 231-191 284-89 61-230 95-326 78zm60-752v-750l-41-88c-22-48-49-106-59-128s-35-76-55-120c-21-44-57-125-82-180s-80-176-123-270c-43-93-88-192-100-220-22-49-58-128-107-235-14-30-33-73-43-95s-35-76-55-120c-21-44-62-134-92-200s-64-140-75-165-33-72-48-105-40-87-55-120-41-89-57-125c-48-105-77-168-129-278-27-57-49-105-49-107s-16-39-36-82c-39-85-76-165-104-228-10-22-44-93-74-159-31-65-56-120-56-122s-16-39-36-81c-20-43-53-114-74-158s-61-132-90-195-65-142-80-175c-27-58-53-116-110-240-69-150-86-187-136-294-30-62-54-115-54-117s-25-56-55-119c-30-64-55-118-55-120 0-1-23-52-51-111-51-110-68-146-133-286-20-43-51-111-70-150-18-40-44-95-56-123-12-27-43-93-67-145-25-52-71-151-103-220-78-169-113-245-176-379-30-62-54-114-54-116s-25-57-56-122-117-248-191-408c-163-350-157-338-426-905-219-464-480-1006-557-1161-25-51-41-93-37-103 6-15 133-16 1599-14l1593 3 3 1541 2 1542-71 58c-270 221-464 543-541 898-32 148-32 446 1 596 89 417 322 764 666 992 245 163 471 238 788 262l67 5-2-437-3-437-65-6c-91-9-143-25-235-69-154-74-276-215-337-391-30-87-32-104-32-219 0-114 3-133 31-213 41-116 84-186 164-266 79-80 150-123 266-164 79-28 100-31 208-32 137 0 217 20 340 83 107 55 221 174 273 283 52 110 74 204 74 309 0 208-101 419-255 536-109 83-268 143-374 144h-43v880h28c49 0 205-20 285-36 313-63 646-260 854-505 367-435 476-985 298-1516-73-219-196-413-383-604l-75-77 7-128c4-71 11-212 16-314 6-102 17-315 25-475 22-424 33-635 50-960 8-159 20-375 25-480 22-430 43-790 45-792 7-9 2692-13 2704-5 12 9 9 21-17 77-18 36-32 68-32 70 0 3-16 39-35 81-19 41-35 77-35 80 0 2-18 43-40 90s-40 88-40 90-13 32-29 66c-15 35-68 153-116 263s-100 228-116 263-29 65-29 67c0 3-14 35-31 72-17 38-96 217-176 398-79 182-154 350-165 375s-162 367-335 760-327 743-344 778c-16 35-29 65-29 67 0 3-13 33-29 67-15 35-76 173-135 308s-117 265-128 290-45 101-75 170-63 145-75 170c-11 25-94 214-185 420-90 206-174 395-185 420s-36 81-55 125-46 105-60 134c-13 30-45 102-70 160-24 59-56 131-70 161s-65 147-115 260c-49 113-100 228-112 255-13 28-45 100-71 160-26 61-62 143-81 183-19 41-34 76-34 78s-13 32-29 66c-15 35-160 362-320 728-161 366-302 685-313 710s-45 101-75 170-63 144-74 168c-19 41-19 67-19 809 0 422 2 769 5 771 2 3 33-1 67-8 132-25 254-119 315-241 17-35 90-199 163-364 72-165 135-309 140-320 33-72 78-175 192-435 71-162 137-313 147-335 20-43 293-663 443-1005 49-113 100-227 112-255 13-27 45-99 71-160 26-60 61-139 77-175s50-112 75-170 57-130 70-160c14-30 173-392 355-805 181-412 337-768 347-790s134-303 276-625c141-322 270-613 286-648s29-65 29-67c0-3 13-33 29-67 15-35 70-157 120-273 51-115 98-223 106-240 7-16 41-93 75-170 33-77 67-153 75-170 7-16 48-109 90-205s85-195 97-220c11-25 43-97 70-160 28-63 61-140 75-170s115-260 225-510c109-250 209-475 220-500s36-81 55-125 45-102 57-130c13-27 45-99 71-160 26-60 62-143 81-183 19-41 34-76 34-79s16-39 35-80 35-77 35-79 13-32 29-66c15-35 52-117 81-183s64-145 77-175c84-185 88-198 88-315 0-105-2-114-33-178-62-125-187-222-316-246-84-15-3888-15-3971 0-156 29-302 164-340 315-8 35-21 180-30 359-8 165-20 388-25 495-6 107-17 321-25 475s-19 368-25 475-17 323-25 480-20 375-25 485c-6 110-15 277-20 370-5 94-10 176-10 183 0 9-26 12-95 12-52 0-96-1-97-2-2-2-5-752-8-1668l-5-1665-34-69c-61-124-187-221-320-246-74-14-4458-14-4532 0-120 23-244 111-303 216-88 158-72 338 44 489 47 60 198 354 431 835 166 345 547 1147 674 1420 34 74 84 180 110 235s108 231 182 390c74 160 153 328 175 375 32 69 179 384 443 955 188 406 230 498 252 545 14 30 38 82 53 115 57 124 84 183 126 273 24 52 44 95 44 97 0 1 23 52 51 111 134 288 179 386 179 389 0 2 23 52 51 112 28 59 59 126 69 148 54 117 81 177 110 240 46 100 77 167 127 275 25 52 55 121 69 152 13 31 49 110 80 175s73 156 94 203c35 79 67 149 125 275 13 28 37 82 55 120 18 39 42 93 55 120 135 291 208 453 240 525 18 41 48 109 68 150 34 74 55 119 117 255 18 39 45 98 61 131 15 34 83 182 150 330 66 148 131 292 144 319 13 28 39 84 58 125s44 98 57 125c24 54 40 90 93 205 19 41 45 98 57 125 12 28 35 77 50 110s38 83 50 110c112 247 109 242 150 296 76 101 201 170 323 178 16 1 17-41 17-748zm35-871c15-36 37-87 50-115 12-27 46-104 75-170s66-148 81-183c16-35 29-65 29-68 0-2 18-43 40-90s40-88 40-90 16-38 35-80c19-41 35-77 35-80 0-2 18-43 40-90s40-88 40-90 13-32 29-66c15-35 70-157 120-273 51-115 98-223 106-240 7-16 48-109 90-205s83-188 90-205c7-16 41-93 75-170s72-162 84-190c13-27 45-99 71-160 26-60 60-138 76-173s29-65 29-68c0-2 18-43 40-90s40-88 40-90 16-38 35-80c19-41 35-77 35-80 0-2 18-43 40-90s40-88 40-90 13-32 29-66c15-35 52-117 81-183 46-106 81-186 140-320 10-22 52-119 95-215 42-96 83-188 90-205 7-16 41-93 75-170s67-153 75-170c7-16 39-88 70-160 32-71 70-158 86-193s29-65 29-68c0-2 18-43 40-90s40-88 40-90 11-27 24-56c27-59 216-488 321-728 37-85 78-177 90-205 12-27 48-108 79-180 32-71 63-143 71-160 7-16 41-93 75-170s71-160 82-185 43-97 70-160c28-63 63-143 79-178s29-65 29-68c0-2 23-55 51-117 66-146 68-150 133-299 88-202 163-372 227-516 32-73 59-135 59-137s13-32 29-67c87-189 118-264 113-272-4-8-2681-1-2688 7-2 2-23 376-44 782-5 105-17 321-25 480-17 325-28 536-50 960-8 160-19 373-25 475-5 102-12 241-16 310l-6 125 57 55c441 428 594 1055 400 1635-157 468-525 832-995 984-282 91-578 102-862 30-638-160-1097-682-1178-1339-35-290 24-621 161-891 83-165 250-372 398-493l71-58V5250H7630c-1068 0-1590 3-1590 10 0 6 29 68 64 138 113 226 806 1681 853 1792 9 19 44 95 79 168 35 74 64 136 64 138s32 69 70 150c39 80 70 147 70 149 0 3 50 109 132 285 22 47 53 112 68 145 64 139 85 185 128 275 24 52 68 147 97 210 96 211 148 322 222 480 25 52 53 113 63 135 29 66 70 154 126 274 30 62 54 115 54 117s25 56 55 119c30 64 55 118 55 120 0 1 20 45 44 96 24 52 54 117 66 144 13 28 37 82 55 120 37 78 84 181 122 265 14 30 45 97 69 148 24 52 44 95 44 97 0 1 23 52 51 111 28 60 59 127 69 149s35 76 55 120 69 150 107 235c39 85 85 187 103 225 18 39 43 93 55 120 12 28 38 84 57 125 20 41 43 93 53 115s33 74 53 115c19 41 45 98 57 125 34 75 79 174 105 230 75 163 101 219 183 400 49 110 107 236 127 280s48 105 62 135 33 73 43 95 33 72 50 110c37 82 56 122 103 225 19 41 45 98 57 125 12 28 36 79 52 115 17 36 34 76 39 89 12 31 21 22 54-59zm124-3776c231-52 441-263 497-500 52-222-14-451-176-615-128-129-271-196-445-206-305-18-590 189-681 492-28 92-26 268 4 363 56 178 179 327 341 411 147 76 289 93 460 55z'
//     />
//   ),
//   });

export const FoxIcon = createIcon({
  // eslint-disable-next-line prettier/prettier
  displayName: "FoxIcon",
  viewBox: '0 0 1000 1000',
  path: (
    <svg viewBox='353.1666 300.136 232.0093 215.6507'>
      <defs>
        <linearGradient
          id='linearGradient28'
          spreadMethod='pad'
          gradientTransform='matrix(-33.64682,145.74033,145.74033,33.64682,412.00977,336.31641)'
          gradientUnits='userSpaceOnUse'
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop
            id='stop24'
            offset={0}
            style={{
              stopOpacity: 1,
              stopColor: '#ed1c24',
            }}
          />
          <stop
            id='stop26'
            offset={1}
            style={{
              stopOpacity: 1,
              stopColor: '#a81d21',
            }}
          />
        </linearGradient>
        <linearGradient
          id='linearGradient48'
          spreadMethod='pad'
          gradientTransform='matrix(-32.392517,-84.385437,-84.385437,32.392517,343.64209,445.64209)'
          gradientUnits='userSpaceOnUse'
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop
            id='stop44'
            offset={0}
            style={{
              stopOpacity: 1,
              stopColor: '#ed1c24',
            }}
          />
          <stop
            id='stop46'
            offset={1}
            style={{
              stopOpacity: 1,
              stopColor: '#a81d21',
            }}
          />
        </linearGradient>
        <linearGradient
          id='linearGradient68'
          spreadMethod='pad'
          gradientTransform='matrix(72.184479,-45.105865,-45.105865,-72.184479,338.68848,385.10596)'
          gradientUnits='userSpaceOnUse'
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop
            id='stop64'
            offset={0}
            style={{
              stopOpacity: 1,
              stopColor: '#ed1c24',
            }}
          />
          <stop
            id='stop66'
            offset={1}
            style={{
              stopOpacity: 1,
              stopColor: '#a81d21',
            }}
          />
        </linearGradient>
        <clipPath id='clipPath78' clipPathUnits='userSpaceOnUse'>
          <path id='path76' d='M 0,720 H 720 V 0 H 0 Z' />
        </clipPath>
      </defs>
      <g
        transform='matrix(1.3333332538604736, 0, 0, -1.3333332538604736, 0, 959.9999999999999)'
        id='g10'
      >
        <g id='g12'>
          <g id='g14'>
            <g id='g20'>
              <g id='g22'>
                <path
                  id='path30'
                  style={{
                    fill: 'url(#linearGradient28)',
                    fillRule: 'evenodd',
                    stroke: 'none',
                  }}
                  d='m 358.719,453.9 32.727,-120.74 h 47.436 l -40.62,161.738 z'
                />
              </g>
            </g>
          </g>
        </g>
        <g id='g32'>
          <g id='g34'>
            <g id='g40'>
              <g id='g42'>
                <path
                  id='path50'
                  style={{
                    fill: 'url(#linearGradient48)',
                    fillRule: 'evenodd',
                    stroke: 'none',
                  }}
                  d='m 346.909,494.809 h 51.195 L 316.069,333.16 h -51.194 z'
                />
              </g>
            </g>
          </g>
        </g>
        <g id='g52'>
          <g id='g54'>
            <g id='g60'>
              <g id='g62'>
                <path
                  id='path70'
                  style={{
                    fill: 'url(#linearGradient68)',
                    fillRule: 'evenodd',
                    stroke: 'none',
                  }}
                  d='m 308.316,383.457 70.391,-50.297 h 60.175 L 327.92,418.774 Z'
                />
              </g>
            </g>
          </g>
        </g>
        <g id='g72'>
          <g clipPath='url(#clipPath78)' id='g74'>
            <g transform='translate(420.9629,296.3809)' id='g80' />
          </g>
        </g>
      </g>
    </svg>
  ),
})
